// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__sAFYQ","signatureButtonsRight":"ModalSign_signatureButtonsRight__18qhG"};